import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getAssignEntitledLeaveApplication: (state) => state.leave,
  getPersonalLeaveApplicationList: (state) => state.items,
  getPersonalLeaveApplicationListPagination: (state) => state.pagination,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
